import { z } from "zod";

import { machineCorrugateTrackMaterialSchema } from "./utils/machine-corrugate-track";

export const changeCorrugateTrackSchema = z
	.object({
		trackNumber: z.number(),
		trackOffset: z.number(),
		loadedCorrugate: machineCorrugateTrackMaterialSchema.nullish(),
		assignedMaterial: machineCorrugateTrackMaterialSchema.nullish(),
	})
	.passthrough();

export const changeCorrugateTracksSchema = z.array(changeCorrugateTrackSchema);

export type ChangeCorrugateTrack = z.infer<typeof changeCorrugateTrackSchema>;
